export const closingDetailsPage = {
	downloadClosingButton: "Download Fechamento",
};
